import React from 'react';

import { SearchInput2 } from '@gogame/components';

import {
  SEARCH,
  SEARCH_QUERY,
  useScreenDispatch,
  useScreenState,
} from '../Screen';
import { ThroughFiltersComponent } from './throughFilters';

const SearchField = ({
  disabled,
  placeholder = 'Search',
  screenStateKey = SEARCH_QUERY,
  tooltip = 'Search',
  applyFilters = false,
  expandedWidth,
  actions,
}) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const handleEnter = async (_e, value) => {
    dispatch({
      type: SEARCH,
      payload: value,
    });
  };

  const value = screenState[screenStateKey] || '';
  return (
    <SearchInput2
      placeholder={placeholder}
      onEnter={handleEnter}
      value={value}
      disabled={disabled}
      debounceTimeout={0}
      tooltip={tooltip}
      expandedWidth={expandedWidth}
      actions={[
        ...(actions ? actions : []),
        ...(applyFilters ? [<ThroughFiltersComponent value={value} />] : []),
      ]}
    />
  );
};

export default SearchField;
// import React, { useContext, useState, useEffect, useRef } from 'react';
//
// import { SearchInput } from '@gogame/components';
//
// import { SEARCH } from '../Screen';
// import ScreenContext from '../Screen/ScreenContext';
//
// const DefaultSearchField = (props) => (
//   <SearchInput data-cy={'SearchField'} {...props} />
// );
//
// export const ScreenSearchField = ({
//   value: propValue,
//   onChange,
//   onSearch,
//   onKeyPress,
//   component: Component = DefaultSearchField,
//   applyFilters = false,
//   actions,
//   ...props
// }) => {
//   const [value, setValue] = useState(propValue);
//   const _valueRef = useRef(value);
//   const _propValueRef = useRef(propValue);
//
//   _valueRef.current = value;
//   _propValueRef.current = propValue;
//
//   const handleChange = (e, v) => {
//     setValue(v);
//
//     if (e.key === 'Enter' && onSearch && _propValueRef.current !== v) {
//       onSearch(e, v);
//     }
//
//     if (onChange) {
//       onChange(e, v);
//     }
//   };
//
//   const handleClear = (e) => onSearch(e, undefined);
//
//   useEffect(() => {
//     setValue(propValue || '');
//   }, [propValue]);
//
//   return (
//     <Component
//       value={value}
//       onChange={handleChange}
//       onClear={handleClear}
//       debounceTimeout={0}
//       margin={'none'}
//       dark={true}
//       fullWidth={true}
//       throughFiltersComponent={applyFilters ? ThroughFiltersComponent : null}
//       {...props}
//     />
//   );
// };
//
// ScreenSearchField.defaultProps = {
//   placeholder: 'Search',
//   variant: 'outlined',
// };
//
// export default (props) => {
//   const { screenState, dispatch } = useContext(ScreenContext);
//   const handleSearch = (_e, value) => {
//     dispatch({
//       type: SEARCH,
//       payload: value,
//     });
//   };
//
//   return (
//     <ScreenSearchField
//       {...props}
//       value={screenState.searchQuery}
//       onSearch={handleSearch}
//       fullWidth={true}
//     />
//   );
// };
